// extracted by mini-css-extract-plugin
export default {"InvestmentFlowDetails":"styles_InvestmentFlowDetails__rHK1R"};